import { render, staticRenderFns } from "./MainPartners.vue?vue&type=template&id=bfb4db60&scoped=true"
import script from "./MainPartners.vue?vue&type=script&lang=js"
export * from "./MainPartners.vue?vue&type=script&lang=js"
import style0 from "./MainPartners.vue?vue&type=style&index=0&id=bfb4db60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb4db60",
  null
  
)

export default component.exports